<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">  
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord()"
    />
    <feather-icon icon="FileIcon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="exportGroup" />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "CellRendererActions",
  methods: {
    editRecord() {
      this.$router.push({ 
        name: 'group-edit', 
        params: {
                  GroupId: this.params.group.GroupId
                } 
      })
    },
    exportGroup(){
      this.$vs.loading();
      this.$store.dispatch("agendaManagement/fetchAttendeesInGroup", this.params.group.GroupId)
        .then((selectedRows)   => { 
          this.$vs.loading.close();
            if(selectedRows.length){
              var datarow = [];

              datarow.push("GroupName");
              datarow.push("Email");
              datarow.push("FirstName");
              datarow.push("LastName");
              var AttendeeData = [];
              AttendeeData.push(datarow);

              selectedRows.map((row) => {
                //---------------------------------------------------------
                datarow = [];         
                datarow.push(this.params.group.GroupName);
                datarow.push(row.Email ? row.Email.trim() : null);
                datarow.push(row.FirstName ? row.FirstName.trim() : null);
                datarow.push(row.LastName ? row.LastName.trim() : null);
                AttendeeData.push(datarow);
                //---------------------------------------------------------
              });
              debugger;
              let csvContent = "data:text/csv;charset=utf-8,base64;";
              var dt = new Date().toISOString().slice(0, 10);
              AttendeeData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              var filename = "ExportGroup_" + "_" + dt + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              //link.setAttribute("id", "Participance_RT_" + row.TableId);
              link.setAttribute("download", filename);
              document.body.appendChild(link); // Required for FF

              link.click();
            }
            else
            {
              console.log("export completed")
            }
        })
    },
    confirmDeleteRecord() {
             const { value: text } = Swal.fire({
          title: `You are about to delete "${this.params.group.GroupName}"`,
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteRecord();
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess();
      this.$vs.loading();
      /* UnComment below lines for enabling true flow if deleting user */
     this.$store.dispatch("agendaManagement/removeGroupMapping", [{GroupId:this.params.group.GroupId,GroupName:this.params.group.GroupName}])
        .then(()   => { 
          this.$vs.loading.close();
          this.showDeleteSuccess() 
        })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
       // title: "User Deleted",
        text: "The selected group was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully"
      });
    }
  }
};
</script>
